import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { t, tf } from "@/lib/i18n";

export function ConfirmUpdateDialog({ pending, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="customer-import-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("Clienti già presenti")}</AlertDialogTitle>
          <AlertDialogDescription>
            {tf("{u} clienti del file hanno una P.IVA già in rubrica e verranno aggiornati con i nuovi dati. Gli altri {n} verranno aggiunti. Vuoi continuare?",
              { u: pending?.updates ?? 0, n: (pending?.rows.length ?? 0) - (pending?.updates ?? 0) })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="customer-import-cancel-btn">{t("Annulla")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="customer-import-confirm-btn">{t("Aggiorna e importa")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
